import axiosInstance from './api';

import { loadUser } from './storage';

import { updateAccessToken } from '../features/user/userSlice';

const axiosInterceptors = (store) => {
  // const { user } = store.getState().user;
  const { dispatch } = store;

  // console.log('user top', user);

  axiosInstance.interceptors.request.use(
    (config) => {
      const user = loadUser();
      const token = user?.accessToken;
      if (
        config.url !== '/user/login' &&
        config.url !== '/user/refresh-token' &&
        token
      ) {
        // console.log('token', token);
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      if (
        originalConfig.url !== '/user/login' &&
        originalConfig.url !== '/user/refresh-token' &&
        err.response
      ) {
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          const user = loadUser();
          const refreshToken = user?.refreshToken;
          // console.log('refreshtoken', refreshToken);
          if (refreshToken) {
            try {
              const rs = await axiosInstance.post('/user/refresh-token', {
                refreshToken,
              });
              if (rs.data.accessToken && rs.data.accessTokenExpires) {
                dispatch(updateAccessToken(rs.data));
                //   TokenService.updateLocalAccessToken(accessToken);
              }

              return axiosInstance(originalConfig);
            } catch (_error) {
              return Promise.reject(_error);
            }
          }
        }
      }

      return Promise.reject(err);
    }
  );
};

export default axiosInterceptors;
